document.addEventListener("DOMContentLoaded", () => {
  try {
    var variantLoaded = document.querySelector(
      "#shopify-section-static-product > script"
    );
    if (variantLoaded) {
      var variants = JSON.parse(variantLoaded.textContent)["product"][
        "variants"
      ];
      var featureImages = variants.map((variant) => {
        var featured_image = variant.featured_image;
        var vid = featured_image.variant_ids[0];
        var alt = featured_image.alt;
        return { vid, alt };
      });
      window.featureImages = featureImages;
    }

    var count = 1;
    for (var c = 0; c < count; c++) {
      setTimeout(() => {
        window.thumbnails = document.querySelectorAll(
          ".tee-slider__track > .tee-slide"
        );
      }, 5000);
    }
  } catch (error) {
    console.warn(error);
  }
});

document.addEventListener("teeinblue-event-variant-changed", (e) => {
  try {
    var vid = e.detail.variantId;
    var alt = window.featureImages.find((e) => e.vid == vid)["alt"];
    // console.log(alt);
    // remove all active image
    // var currentActive = document.querySelector(
    //   ".tee-slider__track > .tee-slide.tee-slide--active"
    // );
    var newActive = Array.from(window.thumbnails).find((e) => {
      var image = e.querySelector(`.tee-mockup img[alt="${alt}"]`);
      return image ? true : false;
    });
    if (newActive) {
      // console.log("found");
    }
  } catch (error) {
    console.warn(error);
  }
});
